import { buildBaseTagularPayload } from './tagular-payload';
import type { TagularEventKind, TagularRegistryEntry } from './types';

export const TAGULAR_SCHEMA_TYPES = {
  ElementClicked: 'redventures.usertracking.v3.ElementClicked',
  ElementViewed: 'redventures.usertracking.v3.ElementViewed',
} as const;

const REGISTRY_KEY_SEPARATOR = '\u0000';

function registryKey(eventKey: string, kind: TagularEventKind): string {
  return `${kind}${REGISTRY_KEY_SEPARATOR}${eventKey}`;
}

const TAGULAR_REGISTRY = new Map<string, TagularRegistryEntry>([
  [
    registryKey('hen.button.clicked', 'interaction'),
    {
      tagularWireName: 'ElementClicked',
      schemaType: TAGULAR_SCHEMA_TYPES.ElementClicked,
      buildPayload: (event, context) =>
        buildBaseTagularPayload(
          event,
          context,
          TAGULAR_SCHEMA_TYPES.ElementClicked,
        ),
    },
  ],
  [
    registryKey('hen.navbar.clicked', 'interaction'),
    {
      tagularWireName: 'ElementClicked',
      schemaType: TAGULAR_SCHEMA_TYPES.ElementClicked,
      buildPayload: (event, context) =>
        buildBaseTagularPayload(
          event,
          context,
          TAGULAR_SCHEMA_TYPES.ElementClicked,
        ),
    },
  ],
  [
    registryKey('hen.link.clicked', 'interaction'),
    {
      tagularWireName: 'ElementClicked',
      schemaType: TAGULAR_SCHEMA_TYPES.ElementClicked,
      buildPayload: (event, context) =>
        buildBaseTagularPayload(
          event,
          context,
          TAGULAR_SCHEMA_TYPES.ElementClicked,
        ),
    },
  ],
  [
    registryKey('hen.navbar.viewed', 'view'),
    {
      tagularWireName: 'ElementViewed',
      schemaType: TAGULAR_SCHEMA_TYPES.ElementViewed,
      buildPayload: (event, context) =>
        buildBaseTagularPayload(
          event,
          context,
          TAGULAR_SCHEMA_TYPES.ElementViewed,
        ),
    },
  ],
  [
    registryKey('hen.hero.viewed', 'view'),
    {
      tagularWireName: 'ElementViewed',
      schemaType: TAGULAR_SCHEMA_TYPES.ElementViewed,
      buildPayload: (event, context) =>
        buildBaseTagularPayload(
          event,
          context,
          TAGULAR_SCHEMA_TYPES.ElementViewed,
        ),
    },
  ],
  [
    registryKey('hen.card.viewed', 'view'),
    {
      tagularWireName: 'ElementViewed',
      schemaType: TAGULAR_SCHEMA_TYPES.ElementViewed,
      buildPayload: (event, context) =>
        buildBaseTagularPayload(
          event,
          context,
          TAGULAR_SCHEMA_TYPES.ElementViewed,
        ),
    },
  ],
  [
    registryKey('hen.emailBanner.viewed', 'view'),
    {
      tagularWireName: 'ElementViewed',
      schemaType: TAGULAR_SCHEMA_TYPES.ElementViewed,
      buildPayload: (event, context) =>
        buildBaseTagularPayload(
          event,
          context,
          TAGULAR_SCHEMA_TYPES.ElementViewed,
        ),
    },
  ],
]);

export function lookupTagularMapping(
  eventKey: string,
  kind: TagularEventKind,
): TagularRegistryEntry | undefined {
  return TAGULAR_REGISTRY.get(registryKey(eventKey, kind));
}

export function listProvisionalTagularMappings(): ReadonlyArray<{
  readonly eventKey: string;
  readonly kind: TagularEventKind;
  readonly tagularWireName: string;
  readonly schemaType: string;
}> {
  const rows: Array<{
    eventKey: string;
    kind: TagularEventKind;
    tagularWireName: string;
    schemaType: string;
  }> = [];

  for (const [key, entry] of Array.from(TAGULAR_REGISTRY.entries())) {
    const [kind, eventKey] = key.split(REGISTRY_KEY_SEPARATOR) as [
      TagularEventKind,
      string,
    ];
    rows.push({
      eventKey,
      kind,
      tagularWireName: entry.tagularWireName,
      schemaType: entry.schemaType,
    });
  }

  return rows;
}
